import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { getCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import type { ThreeUpView } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import { getColumnWidth } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/merchandiser/helpers/MerchandiserCommon';

export const getThreeUpCard = (
  section: ThreeUpView,
  styles: ThreeUpView['styles']
): GridCard<PlaneTypes.Layout_ThreeUp> => {
  const card = getCard<PlaneTypes.Layout_ThreeUp>({
    data: { ...section, styles, sectionId: section.id },
    type: PlaneTypes.Layout_ThreeUp,
    size: { width: getColumnWidth(), height: styles!.boxSize.height },
    blockHover: true,
  });

  card.key = card.data?.key;

  return card;
};
